import gql from 'graphql-tag';

export const RequestUploadAccessMutation = gql`
  mutation requestUploadAccess($uploadType: uploadTypeEnum) {
    requestUploadAccess(uploadType: $uploadType) {
      json
    }
  }
`;
